module.exports = {
      id: "game-shop-usage",
      viewBox: "0 0 48.679 33.19",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#game-shop",
      toString: function () {
        return this.url;
      }
    }